import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * ProtectedRoute — waits for auth bootstrap, then redirects to /signin when
 * there is no authenticated user (guest OR email). Guest access is gained by
 * tapping "Continue as Guest" on the SignIn screen.
 */
export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="mobile-container flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="text-6xl font-black font-heading text-graphite animate-pulse-soft">B</div>
          <div className="text-xs uppercase tracking-wider text-graphite/60 mt-2">Loading</div>
        </div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/signin" replace />;
  }

  return children;
};
